/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
function o(r, n, e) {
  return r ? n(r) : e == null ? void 0 : e(r);
}
export {
  o as n
};
//# sourceMappingURL=when-CDK1Tt5Y.js.map
